module.exports = __webpack_public_path__ + "static/media/7.b2d29bc3.svg";